import axios from 'axios';
const ApiRootUrl = "https://www.kejiaoshu.com:8080/"
const imgServer = 'https://robot'
export const PictureServer = {
	Post: imgServer + 'p-1305194676.cos.ap-nanjing.myqcloud.com/',
    Class: imgServer + 'c-1305194676.cos.ap-nanjing.myqcloud.com/',
    TheClass: imgServer + 'cla-1305194676.cos.ap-nanjing.myqcloud.com/',
    Standby: imgServer +'cer-1305194676.cos.ap-guangzhou.myqcloud.com/'
}
const req = (method, url, params = {}) => {
	return axios({
		method: method,
		url: url,
		data: params,
		headers: {
			'Content-Type': 'application/json',
			Authorization: localStorage.getItem('token')
		}
	}).then(res => res.data);
};

// 获取用户菜单
export const menu = (params) => {
	return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data)
};
// 退出接口
export const loginout = () => {
	return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data)
};

/**
 * 用户管理
 **/
// 用户管理-获取用户列表
export const userList = (params) => {
	return req("post", "/api/User/list", params)
};
// 用户管理-保存（添加编辑）
export const userSave = (params) => {
	return req("post", "/api/User/save", params)
};
// 用户管理-删除用户
export const ReSetTheComUserKeymUserKeymUserKey = (params) => {
	return axios.delete("/api/User/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(
		res => res.data)
};
// 用户管理-重置密码
export const userPwd = (params) => {
	return req("post", "/api/User/pwd", params)
};
// 用户管理-修改状态
export const userLock = (params) => {
	return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage
		.getItem('logintoken'))
};
// 用户管理-数据权限
export const UserDeptTree = (params) => {
	return axios.get("/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken'))
};
// 用户管理-数据权限保存
export const UserDeptSave = (params) => {
	return req("post", "/api/UserDept/save", params)
};
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => {
	return axios.get("/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken'))
};
// 用户管理-保存部门设置
export const UserChangeDept = (params) => {
	return req("post", "/api/User/change/dept", params)
};
// 用户管理-用户下线
export const userExpireToken = (params) => {
	return req("get", "/api/User/expireToken/" + params, {})
};
// 用户管理-刷新缓存
export const userFlashCache = (params) => {
	return req("get", "/api/User/flashCache/" + params, {})
};

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => {
	return req("post", "/api/Module/list")
};
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => {
	return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken'))
};
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => {
	return req("post", "/api/Module/nodes", params)
};
// 菜单管理-修改菜单
export const ModuleSave = (params) => {
	return req("post", "/api/Module/save", params)
};
// 菜单管理-删除菜单
export const ModuleDelete = (params) => {
	return axios.delete("/api/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(
		res => res.data)
};

/**
 * 订单管理
 **/
//export const adminiMainAd = (params) => { return req("get", ApiRootUrl+"admini/adminiMainAd", params) };
/**
 * 推广
 **/
// 广告管理
export const adminiMainAd = (params) => {
	return req("get", ApiRootUrl + "admini/adminiMainAd", params)
};
export const deleteMainAd = (params) => {
	return req("get", ApiRootUrl + "admini/deleteMainAd?id=" + params)
};
export const addMainAd = (params) => {
	return req("post", ApiRootUrl + "admini/addMainAd", params)
};
// 海报管理
export const getPosterList = (params) => {
	return req("get", ApiRootUrl + "admini/getPosterList", params)
};
export const deletePoster = (params) => {
	return req("get", ApiRootUrl + "admini/deletePoster?id=" + params)
};
export const addPoster = (params) => {
	return req("post", ApiRootUrl + "admini/addPoster", params)
};
//快递
export const getKDtokrn = (params) => {
	return req("get", ApiRootUrl + "admini/getKDtokrn", params)
};
export const frushKDtokrn = (params) => {
	return req("post", ApiRootUrl + "admini/frushKDtokrn", params)
};
//审核
// 获取新店请求
export const newShop = () => {
	return req("get", ApiRootUrl + "admini/examineNewShop")
};
export const approvalNewShop = (params) => {
	return req("get", ApiRootUrl + "admini/submitNewExamineShop?id=" + params)
};
export const noNewShop = (params) => {
	return req("get", ApiRootUrl + "admini/noNewExamineShop?id=" + params)
};
export const frushLog = (params) => {
	return req("get", "https://www.baidu.com")
};
// 获取资源内容
export const examineAd = () => {
	return req("get", ApiRootUrl + "admini/examineAd")
};
export const approvalAd = (params) => {
	return req("get", ApiRootUrl + "admini/approvalAd?id=" + params)
};
export const noAd = (params) => {
	return req("get", ApiRootUrl + "admini/noApprovalAd?id=" + params)
};
// 获取资源内容
export const examineGoods = () => {
	return req("get", ApiRootUrl + "admini/examineGoods")
};
export const submitExamineGoods = (params) => {
	return req("get", ApiRootUrl + "admini/submitExamineGoods?id=" + params)
};
//获得修改的店铺设置
export const examineShop = () => {
	return req("get", ApiRootUrl + "admini/examineShop")
};
export const submitExamineShop = (params) => {
	return req("get", ApiRootUrl + "admini/submitExamineShop?id=" + params)
};
export const noExamineShop = (params) => {
	return req("get", ApiRootUrl + "admini/noExamineShop?id=" + params)
};

//获得店铺结算信息
export const getShopAccount = () => {
	return req("get", ApiRootUrl + "admini/getShopAccount")
};
export const submitShopAccount = (params, t0, t1) => {
	return req("get", ApiRootUrl + "admini/submitShopAccount?id=" + params)
};

//获得订单信息
export const getOrderdetail = (t, sid) => {
	return req("get", ApiRootUrl + "admini/getOrderdetail?t=" + t + "&sid=" + sid)
};
export const orderRefund = (oid, pid, sid) => {
	return req("get", ApiRootUrl + "admini/submitOrderRefund?id=" + oid + "&pid=" + pid + "&sid=" + sid)
};


//公司用户管理
//获取用户列表
export const GetCompanyUserList = (t) => {
	return req("get", ApiRootUrl + "swebBackstage/getCompanyUserList?t=" + t)
};
//提交新用户
export const SubmitUserSave = (params) => {
	return req("post", ApiRootUrl + "swebBackstage/submitUserSave", params)
};
//删除用户
export const DeleteTheComUser = (id) => {
	return req("get", ApiRootUrl + "swebBackstage/deleteTheComUser?id=" + id)
};
//更新用户密码
export const ReSetTheComUserKey = (id, key) => {
	return req("get", ApiRootUrl + "swebBackstage/reSetTheComUserKey?id=" + id + "&k=" + key)
};

//公司仍任务管理
//待上线任务
//公司获取发布的工作
export const GetTheRecruiting = (t) => {
	return req("get", ApiRootUrl + "admini/getTheRecruiting?t=" + t)
};
//公司上传新工作
export const SubmitAddNewWorks = (params) => {
	return req("post", ApiRootUrl + "admini/submitAddNewWorks", params)
};
//上线工作
export const OnlineTheWork = (params) => {
	return req("get", ApiRootUrl + "admini/onlineTheWork?id=" + params)
};
//招募中

//获取工作详情以开始
export const GetTheWorkInfoToBegin = (params, t) => {
	return req("get", ApiRootUrl + "admini/getTheWorkInfoToBegin?id=" + params + '&t=' + t)
};
//拒绝或选中
export const RefuseTheStu = (id, t, tid, k) => {
	return req("get", ApiRootUrl + "admini/refuseTheStu?id=" + id + "&t=" + t + "&tid=" + tid + "&k=" + k)
};

export const StartingAndOffline = (id, t) => {
	return req("get", ApiRootUrl + "admini/startingAndOffline?id=" + id + "&t=" + t)
}


//主办方
//获取邀请码申请列表
export const GetTheWorktingList = () => {
	return req("get", ApiRootUrl + "admini/getTheWorktingList")
};
//获取邀请码申请详情
export const GetTheWorkInfo = (cid,sid,uid) => {
	return req("get", ApiRootUrl + "admini/getTheWorkInfo?cid=" + cid+'&sid='+sid+'&uid='+uid)
};
//提交邀请码审核结果
export const SubmitReviewResults = (params) => {
	return req("post", ApiRootUrl + "admini/submitReviewResults", params)
};


//获取教师审核列表
export const GetTheTeacherList = () => {
	return req("get", ApiRootUrl + "admini/getTheTeacherList")
};
//获取老师申请详情
export const GetTheApTeacherInfo = (id) => {
	return req("get", ApiRootUrl + "admini/getTheApTeacherInfo?id=" + id)
};
//提交老师审核结果
export const SubmitReviewTeacher = (params) => {
	return req("post", ApiRootUrl + "admini/submitReviewTeacher", params)
};

//获取私有任务
export const GetpritiveWorkList = () => {
	console.log(8998)
	return req("get", ApiRootUrl + "admini/getpritiveWorkList")
};
//获取私有已完成日志详情
export const GetpritiveWorkLogList = (id, wid) => {
	return req("get", ApiRootUrl + "admini/getpritiveWorkLogList?id=" + id + "&wid=" + wid)
};
//获取私有已完成任务详情
export const GetpritiveeWorkInfoToReceive = (params) => {
	return req("post", ApiRootUrl + "admini/getpritiveWorkInfoToReceive", params)
};






//学校
//学校获取首页公告列表
export const GetSchoolAdList = () => {
	return req("get", ApiRootUrl + "swebBackstage/getSchoolAdList")
};
//学校上传学校公告
export const SubmitTheSchoolAd = (params) => {
	return req("post", ApiRootUrl + "swebBackstage/submitTheSchoolAd", params)
};
//学校删除学校公告
export const DeleteTheSchoolAd = (id) => {
	return req("get", ApiRootUrl + "swebBackstage/deleteTheSchoolAd?id=" + id)
};
//学校更新首页通知
export const UpdateTheHomeInfo = (params) => {
	return req("post", ApiRootUrl + "swebBackstage/updateTheHomeInfo", params)
};

//学校获取活动列表
export const GetSchoolActiveList = () => {
	return req("get", ApiRootUrl + "swebBackstage/getSchoolActiveList")
};
//学校上传活动
export const SubmitTheSchoolActive = (params) => {
	return req("post", ApiRootUrl + "swebBackstage/submitTheSchoolActive", params)
};
//学校删除学校公告
export const DeleteTheSchoolActive = (id) => {
	return req("get", ApiRootUrl + "swebBackstage/deleteTheSchoolActive?id=" + id)
};

//学校查询公司
//初始化推荐
export const  RecSomeCompanies= (t) => {
	return req("get", ApiRootUrl + "swebBackstage/recSomeCompanies?t="+t)
};
//搜索相关公司
export const SearchTheCompanies= (params) => {
	return req("post", ApiRootUrl + "swebBackstage/searchTheCompanies",params)
};
//查看公司详情
export const LookTheCompanies= (id) => {
	return req("get", ApiRootUrl + "swebBackstage/lookTheCompanies?id="+id)
};


//公开链接
//查看是否报名
export const HnsmarteduIsReged= (t) => {
	return req("get", ApiRootUrl + "public/hnsmartedu_isreged?t="+t)
};
export const HnsmarteduRegistration= (id) => {
	return req("get", ApiRootUrl + "public/hnsmartedu_registration?t="+id)
};
//查看是否报名
export const verificationCertificate= (id,code,cid) => {
	return req("get", ApiRootUrl + "public/verificationCertificate?id="+id+"&code="+code+"&cid="+cid)
};



import COS from 'cos-js-sdk-v5';
export function uploadFile(file, name) {
	console.log(file, name)
	const Uploader = new COS({
		SecretId: 'AKIDEZeUSDhuqWw5xZuylIekdGdldFbhYAWb',
		SecretKey: 'vc3FCuMZWDfsoVxA7oHUS9ZjcGfpjNlu',
	});
	return new Promise(resolve => {
		Uploader.putObject({
			Bucket: 'roboti-1305194676',
			Region: 'ap-guangzhou',
			Key: name,
			Body: file,
			Headers: {
				'x-cos-meta-test': 123
			}
		}, function(err, data) {
			if (err) {
				console.error(err, 43466);

			} else {
				console.log("上传成功", data);
				resolve(data)
			}
		});
	})


}

export function deleteImg(name) {
	const Uploader = new COS({
		SecretId: 'AKIDEZeUSDhuqWw5xZuylIekdGdldFbhYAWb',
		SecretKey: 'vc3FCuMZWDfsoVxA7oHUS9ZjcGfpjNlu',
	});
	Uploader.deleteObject({
		Bucket: 'xuezicyi-1305194676',
		Region: 'ap-guangzhou',
		Key: name,
	}, function(err, data) {
		console.log(err || data);
	});
}


export function findShopCategoyr(id) {
	if (id < 50) {
		return shopcategory[0][id].text
	} else if (id > 50 && id < 80) {
		return shopcategory[1][id - 51].text
	} else {
		return shopcategory[2][id - 81].text
	}
}

export function formatTime(date) {
	return [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(formatNumber).join('-') + ' ' + [date
		.getHours(), date.getMinutes(), date.getSeconds()
	].map(formatNumber).join(':')
}

function formatNumber(n) {
	n = n.toString()
	return n[1] ? n : '0' + n
}
export function calculateAge(birthDate) {
	const today = new Date();
	const birthDateObj = new Date(birthDate);
	let age = today.getFullYear() - birthDateObj.getFullYear();
	const monthDiff = today.getMonth() - birthDateObj.getMonth();
	const dayDiff = today.getDate() - birthDateObj.getDate();
	if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
		age--;
	}
	return age;
}


// WEBPACK FOOTER //
// ./src/api/userMG.js